import React, { useState } from "react";
import "./DeleteAccountPage.css";
import { url } from "../../utils/api";
import { toast, ToastContainer } from "react-toastify";

const DeleteAccountPage = () => {
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Validation: Require at least one field (email or mobile)
    if (!email && !mobile) {
      setError("Please provide either your email or mobile number.");
      return;
    }
    if (email && !/\S+@\S+\.\S+/.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    if (mobile && !/^\+?[1-9]\d{1,14}$/.test(mobile.replace(/\D/g, ""))) {
      setError("Please enter a valid mobile number (e.g., +1234567890).");
      return;
    }

    try {
      // Replace with your client's actual API endpoint for WannaBAE
      const response = await fetch(url + "/Profile/delete-account-request", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, mobile }),
      });

      if (response.ok) {
        setSubmitted(true);
        toast.success("Request submitted successfully.");
      } else {
        setError("Something went wrong. Please try again later.");
      }
    } catch (err) {
      setError(
        "An error occurred. Please check your connection and try again."
      );
    }
  };

  return (
    <div className="delete-account-container">
      <header className="header">
        <h1>Delete Your WannaBAE Account</h1>
        <p>
          We’re sad to see you leave. Submit your request below to permanently
          delete your WannaBAE account.
        </p>
      </header>

      <main className="main-content">
        {!submitted ? (
          <form onSubmit={handleSubmit} className="delete-form">
            <label htmlFor="email">Registered Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value.toLowerCase())}
              placeholder="Enter your email"
            />
            <p style={{ textAlign: "center" }}>------------ Or ---------</p>
            <label htmlFor="mobile">Registered Mobile Number</label>
            <input
              type="tel"
              id="mobile"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              placeholder="Enter your mobile (e.g., +1234567890)"
            />
            {error && <p className="error-message">{error}</p>}
            <button type="submit" className="delete-button">
              Request Account Deletion
            </button>
          </form>
        ) : (
          <div className="success-message">
            <h2>Request Submitted</h2>
            <p>
              Your WannaBAE account deletion request has been received. We’ll
              process it within 30 days. For support, reach out to{" "}
              <a href="mailto:reachus@wannabae.com">reachus@wannabae.com</a>.
            </p>
          </div>
        )}
      </main>

      <footer className="footer">
        <p>
          This page is for WannaBAE account deletion. For more details, see our{" "}
          <a href="https://www.wannabae.com/privacy-policy">Privacy Policy</a>.
        </p>
      </footer>
      <ToastContainer />
    </div>
  );
};

export default DeleteAccountPage;
